import type { TFunction } from 'i18next';

export const CHECKOUT_TYPE_ENUM = {
  CHARGE_CHECKOUT: 'CHARGE_CHECKOUT',
  PIX_AUTOMATIC_CHECKOUT: 'PIX_AUTOMATIC_CHECKOUT',
} as const;

export const checkoutTypei18n = (t: TFunction, key: string) => {
  const keys = {
    [CHECKOUT_TYPE_ENUM.CHARGE_CHECKOUT]: t('Charge Checkout'),
    [CHECKOUT_TYPE_ENUM.PIX_AUTOMATIC_CHECKOUT]: t('Pix Automatic Checkout'),
  };

  return keys[key as keyof typeof CHECKOUT_TYPE_ENUM];
};
